import { render, staticRenderFns } from "./pagesNosotros.vue?vue&type=template&id=f6504c34"
import script from "./pagesNosotros.vue?vue&type=script&lang=js"
export * from "./pagesNosotros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports